import { capitalize } from '@pdcfrontendui/utils';
import { localStorageRemove } from './util/localStorage';
import { LocalStorageKey } from './util/LocalStorageKey';
import { getLangState, setCurrentLangCode } from './hooks/useLang';
import {
  LanguageCode,
  langMap,
  Language,
  isLanguageCode,
} from '@pdcplan/shared/generated/language/TeamPlan';

let defaultLanguageId: LanguageCode = LanguageCode.Da;

export function setDefaultLanguageId() {
  const browserLanguageCapitalized = capitalize(
    navigator.language || defaultLanguageId
  ).slice(0, 2);

  if (isLanguageCode(browserLanguageCapitalized)) {
    defaultLanguageId = browserLanguageCapitalized;
  }
}

export let currentLanguage: Language;

export function setCurrentLanguage(id: LanguageCode) {
  if (!isLanguageCode(id)) {
    // Prevent the same error from re-occurring when the application reloads
    localStorageRemove(LocalStorageKey.currentLanguage);
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    throw new Error('Unknown language: ' + id);
  }
  currentLanguage = langMap[id];
  setCurrentLangCode(id);
}

export const getCurrentLanguage = () => {
  return getLangState().currentLangCode;
};

setCurrentLanguage(getCurrentLanguage());
